// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gfKh","type":"styles_type__ZokFq","choices":"styles_choices__1MESx"};